import { useState } from 'react';
import { Col, Form, Row } from 'antd';
import SelectC from 'src/components/Forms/Select';
import CaptchaInput from 'src/components/Inputs/Captcha';
import SubmitFormButton from 'src/components/Inputs/SubmitForm';
import TextAreaInput from 'src/components/Inputs/TextArea';
import TextFieldInput from 'src/components/Inputs/TextField';
// import messageC from 'src/components/Message';
import { fetchApi } from 'src/utils/fetch-api';
import classes from './index.module.less';
import { useMessageC } from '@/utils/useMessage';
const FormContact = () => {
  const [processing, setProcessing] = useState(false);
  const [form] = Form.useForm();
  const messageC = useMessageC();
  const onHandleFinishForm = async (values: any) => {
    // console.log('site-key', process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY);
    // console.log('site-key --', values);
    setProcessing(true);
    const resSubmit = await fetchApi({
      url: '/contactus',
      options: {
        method: 'POST'
      },
      payload: {
        contact_name: values.name,
        contact_us_topic_id: parseInt(values.topik),
        contact_us_type_id: parseInt(values.type),
        email: values.email,
        phone_number: values.phone,
        content: values.content,
        ['recaptcha_response']: values['google-captcha']
      }
    });
    setProcessing(false);
    if (resSubmit.meta.code === 204000) {
      messageC('Sukses mengirim pesan');
      form.resetFields();
    } else {
      messageC('Gagal mengirim pesan', 'error');
      setProcessing(false);
    }
  };
  const typeOptions = [{
    label: 'Tentang Fitur Perencanaan Kehamilan',
    value: '1'
  }, {
    label: 'Tentang Fitur Kehamilan',
    value: '2'
  }, {
    label: 'Tentang Fitur Tumbuh Kembang Anak',
    value: '3'
  }];
  const jenisOptions = [{
    label: 'Keluhan',
    value: '1'
  }, {
    label: 'Masukan',
    value: '2'
  }, {
    label: 'Saran',
    value: '3'
  }, {
    label: 'Pertanyaan',
    value: '4'
  }, {
    label: 'Lainnya',
    value: '5'
  }];
  const checkPhoneNumberFormat = (_: any, value: string) => {
    const regexPhoneNumber = /^[+]*[(]?\d{1,4}[)]?[-\s\./0-9]*$/g;
    if (value.match(regexPhoneNumber)) {
      return Promise.resolve();
    } else if (value.length <= 0) {
      return Promise.reject(new Error('Nomor HP mama harus diisi.'));
    }
    return Promise.reject(new Error('Format nomor HP mama tidak sesuai.'));
  };
  return <Form className={classes.wrapper} autoComplete="off" name="contact-us-form" onFinish={onHandleFinishForm} form={form} layout='vertical'>
			<Row gutter={16}>
				<Col md={24} xs={24} sm={24}>
					<TextFieldInput name="name" label="Nama Mama" placeholder="Nama Mama" rules={[{
          required: true,
          message: 'Nama mama harus diisi'
        }]} />
				</Col>
			</Row>
			<Row gutter={16}>
				<Col md={12} xs={24} sm={24}>
					<TextFieldInput name="phone" label="No. HP Mama" placeholder="Tulis nomor hp mama" rules={[{
          validator: checkPhoneNumberFormat
        }]} />
				</Col>
				<Col md={12} xs={24} sm={24}>
					<TextFieldInput name="email" label="Email Mama" placeholder="Tulis email mama" rules={[{
          required: true,
          message: 'Email mama harus diisi'
        }, {
          type: 'email',
          message: 'Format email mama tidak sesuai'
        }]} />
				</Col>
			</Row>
			<Row gutter={16}>
				<Col md={12} xs={24} sm={24}>
					<SelectC useLabel name="type" label="Jenis Pertanyaan" placeholder="Jenis Pertanyaan" options={jenisOptions} rules={[{
          required: true,
          message: 'Jenis pertanyaan harus diisi'
        }]} className={classes.custom} />
				</Col>
				<Col md={12} xs={24} sm={24}>
					<SelectC useLabel name="topik" label="Topik" placeholder="Topik" options={typeOptions} rules={[{
          required: true,
          message: 'Topik harus diisi'
        }]} className={classes.custom} />
				</Col>
			</Row>

			<Row gutter={16}>
				<Col xs={24}>
					<TextAreaInput name="content" label="Pesan / Pertanyaan" placeholder="Deskripsikan apa yang kamu ingin tanyakan" rules={[{
          required: true,
          message: 'Isi pesan harus diisi'
        }]} />
				</Col>
			</Row>
			<Row className="mt-4 mb-4" gutter={16}>
				<div className={classes.captcha}>
					<Col xs={24} className={classes.captchaBox}>
						<CaptchaInput name="google-captcha" sitekey={`${process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY}`} />
					</Col>
				</div>
			</Row>
			<Row gutter={16}>
				<Col xs={24}>
					<SubmitFormButton label="Kirim" isProcessing={processing} />
				</Col>
			</Row>
		</Form>;
};
export default FormContact;